import { useCookies } from '@/components/composable/composable_cookie'
import type { components, paths } from '@/types/gateway_schema'
import createClient from 'openapi-fetch'
import { defineStore } from 'pinia'
import { toast } from 'vue-sonner'

type GatewayStoreState = {
  user_charts: components['schemas']['ChartDTO'][]
  organization_units?: components['schemas']['SopravisionOrganizationUnitDTO']
}

const client = createClient<paths>({
  baseUrl: '/gateway'
})

export const useGatewayStore = defineStore('gateway', {
  state: (): GatewayStoreState => ({
    user_charts: [],
    organization_units: undefined
  }),
  getters: {
    getJWT: (_) => {
      const { getCookieValue } = useCookies()
      const cookie = getCookieValue('hv_jwt')
      return cookie
    }
  },
  actions: {
    async fetchOrganizationUnits() {
      return client
        .GET('/api/sopravision/organizationUnits', {
          headers: { 'X-AUTH-TOKEN': this.getJWT.value }
        })
        .then((response) => {
          if (response.data) {
            this.organization_units = response.data
          }
        })
    },
    async fetchUserCharts() {
      return client
        .GET('/api/charts', { headers: { 'X-AUTH-TOKEN': this.getJWT.value } })
        .then((response) => {
          if (response.data) {
            this.user_charts = response.data
          }
        })
    },
    async postChart(chart: components['schemas']['ChartDTO']) {
      return client
        .POST('/api/charts', { body: chart, headers: { 'X-AUTH-TOKEN': this.getJWT.value } })
        .then((response) => {
          if (response.data) {
            let name = response.data?.id?.toString().padStart(5, '0')
            if (response.data?.name) {
              name = response.data.name
            }

            this.user_charts.push(response.data)
            toast.success(`Le graphique ${name} à été enregistré.`)
          }
        })
    },
    async patchChart(id: number, chart: components['schemas']['ChartDTO']) {
      return client
        .PATCH('/api/charts/{id}', {
          body: chart,
          headers: { 'X-AUTH-TOKEN': this.getJWT.value },
          params: {
            path: {
              id: id.toString()
            }
          }
        })
        .then((response) => {
          let name = response.data?.id?.toString().padStart(5, '0')
          if (response.data?.name) {
            name = response.data.name
          }

          if (response.data) {
            const key = this.user_charts.findIndex((e) => e.id === id)
            this.user_charts[key] = response.data
            toast.success(`Le graphique ${name} à été sauvegardé.`)
          }
        })
    },
    async deleteChart(id: number) {
      return client
        .DELETE('/api/charts/{id}', {
          headers: { 'X-AUTH-TOKEN': this.getJWT.value },
          params: { path: { id: id.toString() } }
        })
        .then(() => {
          const key = this.user_charts.findIndex((e) => e.id === id)
          this.user_charts.splice(key, 1)
        })
    }
  }
})
